import React from 'react';
import Header from './components/Header/Header';
import Navbar from './components/Navbar/Navbar';
import { Container } from '@pw-tech/omni-ui';
import InitializeComponent from './components/InitializeComponent/InitializeComponent';
const RegisterLayout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <div className="flex flex-col h-screen" data-sentry-component="RegisterLayout" data-sentry-source-file="index.tsx">
      <div className="flex-shrink-0 overflow-x-clip">
        <Container className="mx-auto px-4 !md:px-0 bg-white" data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <Header data-sentry-element="Header" data-sentry-source-file="index.tsx" />
        </Container>
      </div>
      <div className="flex-shrink-0 bg-[url('https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/bdca5f89-31bd-4dc7-bc4a-a9074c870f1c.png')] bg-cover bg-center">
        <Navbar data-sentry-element="Navbar" data-sentry-source-file="index.tsx" />
      </div>

      <InitializeComponent data-sentry-element="InitializeComponent" data-sentry-source-file="index.tsx">{children}</InitializeComponent>
    </div>;
};
export default RegisterLayout;